/**
 * Translator
 * Package: @wayfair/translation
 *
 * @author Ryan Hibbert <rhibbert@wayfair.com>
 * @copyright 2020 Wayfair LLC - All rights reserved
 */

import PropTypes from 'prop-types';

// import from dist because otherwise bundlers pull from "module": "./lib"
// instead of "main": "./dist" ... which has es6 code (library issue, imo)
// https://github.com/formatjs/react-intl/issues/1499 (number of other related issues on their repo)
import {createIntl} from 'react-intl/dist';

// Dummy locale provided for the creation of ReactIntl object. We don't utilize the locale functionality
const locale = 'en';

const Translate = props => {
  if (props.params != null && Object.keys(props.params).length !== 0) {
    const message = {id: 'msgid', defaultMessage: props.msgid};
    const intl = createIntl({locale});

    return intl.formatMessage(message, props.params);
  }

  return props.msgid;
};

Translate.propTypes = {
  msgid: PropTypes.string.isRequired,
  params: PropTypes.object,
};

Translate.defaultProps = {
  params: {},
};

export default Translate;
